export enum DecimalCustomBorders {
  warning = 'warning',
  caution = 'caution',
  helpful = 'helpful',
  plain = 'plain',
}

export const perUnit = 'per Unit';
export const perCase = 'per Case';
